<style>
#therapy-filter .multiselect__content-wrapper {
  min-width: 350px !important;
  max-width: 600px !important;
  overflow-x: hidden !important;
  width: 140% !important;
  z-index: 99999 !important;
}

#therapy-filter .multiselect__content {
  overflow-x: hidden !important;
  width: 100% !important;
}

@media (max-width: 640px) {
  #therapy-filter .multiselect__content-wrapper {
    min-width: 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }
}
</style>

<template>
  <div id="therapy-filter" class="">
    <multiselect
      ref="multiselect"
      v-model="selectedItem"
      :options="options.filter((y) => y.type === 'category')"
      :loading="isLoading"
      :searchable="true"
      :clear-on-select="false"
      :close-on-select="true"
      :preserve-search="false"
      label="name"
      track-by="uId"
      :placeholder="$t('Therapy or specialty...')"
      @search-change="onSearchChange"
      @open="handleOpen"
      class="px-[.2rem] py-[.2rem] rounded-[10rem] border border-white bg-white"
      :show-no-options="false"
      :show-labels="false"
      :custom-label="nameOfSelected"
    >
      <template #singleLabel="{ option }">
        <span>{{ option.name }}</span>
      </template>
      <template #option="{ option }">
        <div class="flex items-center justify-between gap-4">
          <div class="flex items-center gap-2 justify-start">
            <span
              v-if="option.type"
              :class="[
                'inline-block w-6 h-6 mr-2 rounded-full',
                dotClass(option.type),
              ]"
            ></span>
            <span
              class="truncate max-w-[350px] text-left"
              :title="option.name"
              >{{ option.name }}</span
            >
          </div>
          <span
            class="px-3 py-1 text-sm font-semibold uppercase rounded-full whitespace-nowrap"
            :class="badgeClass(option.type)"
          >
            {{ typeLabel(option.type) }}
          </span>
        </div>
      </template>
      <template #noResult>
        <span class="px-2 py-1 text-gray-500">{{
          $t("No results found")
        }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { getTherapyOptions } from "@/services/naaviApi/internalService";

export default {
  components: { Multiselect },
  props: {
    modelValue: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedItem: null,
      options: [],
      isLoading: false,
    };
  },
  watch: {
    selectedItem(newVal) {
      if (this.$refs.multiselect) {
        this.$refs.multiselect.search = "";
      }

      // Emitir el objeto completo
      this.$emit("update:modelValue", newVal || null);

      if (!newVal) {
        this.fetchItems("", "", null, true);
      }
    },
    modelValue(newVal) {
      if (!newVal) {
        this.selectedItem = null;
        return;
      }

      this.selectedItem =
        this.options.find(
          (opt) => opt.uId === newVal.uId && opt.type === newVal.type,
        ) || null;
    },
  },
  mounted() {
    const { name = "", type = "", uId = "" } = this.modelValue || {};
    this.fetchItems(name, type, uId);

    // Observa el DOM para detectar cuando aparece .multiselect__content-wrapper
    const observer = new MutationObserver(() => {
      if (document.querySelector(".multiselect__content-wrapper")) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  },
  methods: {
    nameOfSelected({ name }) {
      return `${name}`;
    },
    typeLabel(type) {
      const labels = {
        category: this.$t("Category label"),
        group: this.$t("Group label"),
        therapy: this.$t("Therapy label"),
      };
      return labels[type] || "";
    },
    badgeClass(type) {
      switch (type) {
        case "category":
          return "bg-purple-100 text-purple-700";
        case "group":
          return "bg-teal-100 text-teal-700";
        case "therapy":
          return "bg-blue-100 text-blue-700";
        default:
          return "bg-gray-200 text-gray-600";
      }
    },
    dotClass(type) {
      switch (type) {
        case "category":
          return "bg-purple-500";
        case "group":
          return "bg-teal-500";
        case "therapy":
          return "bg-blue-500";
        default:
          return "bg-gray-400";
      }
    },
    handleOpen() {
      if (this.$refs.multiselect) {
        this.$refs.multiselect.search = "";
      }
      this.fetchItems("", "", null, true);
    },
    onSearchChange(query) {
      this.fetchItems(query, "", null, true);
    },
    async fetchItems(query, type = "", uId = null, skipSelection = false) {
      this.isLoading = true;
      try {
        const response = await getTherapyOptions({ search: query, type, uId });
        let data = [];
        if (response && response.message && response.message.options) {
          data = response.message.options;
        } else if (
          response &&
          response.data &&
          response.data.message &&
          response.data.message.options
        ) {
          data = response.data.message.options;
        }
        this.options = data;

        if (!skipSelection && this.modelValue) {
          this.selectedItem =
            this.options.find(
              (opt) =>
                opt.uId === this.modelValue.uId &&
                opt.type === this.modelValue.type,
            ) || null;
        }
      } catch (e) {
        void e;
      } finally {
        this.isLoading = false;
      }
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
